// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"90424cb4","452":"79c9a9a9","453":"8826f06f","487":"ffba4163","744":"13d45208"}[chunkId] + ".chunk.js";
};